module.exports = __webpack_public_path__ + "img/traffic-barrier.c919a00d.png";